// extracted by mini-css-extract-plugin
export var arrowChevron = "ij_fb7IbPzcMJrvpPfR7";
export var chevronColor = "var(--dp_app_icon_fill_subtle)";
export var fullWidth = "jZdAHHkvy3cZs3BEUU4x";
export var root = "PnOxeJKbhzG4mzEaECIe";
export var selectContainer = "VKqyIPYoGcRTkKRV4nNQ";